import type { InvoiceSummary } from '../../../types/invoice-summary'
import { buildInvoiceSummary } from '../../../types/invoice-summary'
import { normalizeInvoiceDocument } from './invoice-document-normalizer'

const normalizeInvoiceSummary = function (input: Object): InvoiceSummary {
  return {
    ...buildInvoiceSummary,
    date: new Date(input.date),
    invoiceNumber: input.invoiceNumber,
    invoiceType: input.invoiceType,
    totalAmount: input.totalAmount,
    invoiceDocuments: input.invoiceDocuments.map(normalizeInvoiceDocument)
  }
}

export {
  normalizeInvoiceSummary
}



// WEBPACK FOOTER //
// ./src/services/b2b/normalizer/invoice-summary-normalizer.js